/**
 * ISO 8601 datetime 文字列を指定 locale の文字列に変換する。
 * 不正な ISO の場合は null を返し、 caller が fallback (raw 文字列 / 「不明」 等) を決める。
 * locale 省略時は browser 既定 locale を使う。
 *
 * 既存 callsite (ScenarioLineagePanel.formatSpawnedAt / SceneSummaryFeed.formatGeneratedAt
 * / ConcurrentPlayDialog.formatLastPlayed) で重複していた Date parse + NaN guard を集約する。
 */
export function formatIsoToLocale(iso: string, locale?: string): string | null {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return null;
  return locale === undefined
    ? date.toLocaleString()
    : date.toLocaleString(locale);
}
